import { Link } from "react-router-dom";

/** Compact CTA panel shown after Hero to funnel visitors into the wizard */
export default function CreateCTA() {
  return (
    <section className="border-t border-[#3a3a3a] bg-[#121212]" data-testid="section-create-cta">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-12 gap-6 items-center">
          <div className="col-span-12 md:col-span-7">
            <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#cfff04] mb-3">
              // SolSpur Launchpad
            </div>
            <h2 className="font-display font-black text-3xl sm:text-4xl uppercase tracking-tighter">
              This is what a SolSpur coin looks like.
              <br />
              <span className="text-[#cfff04]">Your turn.</span>
            </h2>
            <p className="text-sm text-[#e2e2e2] mt-3 max-w-xl">
              Pick a name + ticker, our AI draws your logo and writes your whitepaper. Free preview. $19 to publish.
              $49 to feature.
            </p>
          </div>
          <div className="col-span-12 md:col-span-5 flex md:justify-end gap-3 flex-wrap">
            <Link
              to="/create"
              data-testid="cta-create-coin"
              className="btn-brutal bg-[#cfff04] text-[#050505] font-bold uppercase tracking-wider text-sm px-7 py-4 inline-flex items-center gap-2"
            >
              Launch My Coin →
            </Link>
            <Link
              to="/explore"
              data-testid="cta-explore"
              className="btn-ghost border border-[#333] text-white font-bold uppercase tracking-wider text-sm px-7 py-4 inline-flex items-center gap-2"
            >
              Explore Coins
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
